import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBackOfficeListPayments: build.query<
      GetBackOfficeListPaymentsApiResponse,
      GetBackOfficeListPaymentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/payments`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          keyword: queryArg.keyword,
          status: queryArg.status,
          vendor: queryArg.vendor,
          sort: queryArg.sort,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type GetBackOfficeListPaymentsApiResponse =
  /** status 200 OK */ BackOfficePaymentPage;
export type GetBackOfficeListPaymentsApiArg = {
  /** page */
  page?: number;
  /** size */
  size?: number;
  /** keyword to search */
  keyword?: string;
  /** status to search */
  status?: string[];
  /** vendor to search */
  vendor?: string[];
  /** Format is sort=distance:desc,name:asc. Supported keys: createdAt, updatedAt */
  sort?: string[];
};
export type EntityPaymentVendor = "pv-google" | "pv-apple" | "pv-manual";
export type EntityPaymentStatus = "ps-purchased" | "ps-pending" | "ps-canceled";
export type CookieResponse = {
  domain?: string;
  httpOnly?: boolean;
  maxAge?: number;
  name?: string;
  path?: string;
  secure?: boolean;
  value?: string;
};
export type AudioResponse = {
  cookies?: CookieResponse[];
  url?: string;
};
export type AudioMediaResponse = {
  content?: AudioResponse;
  id?: string;
};
export type ImageResponse = {
  type?: string;
  url?: string;
};
export type ImageMediaResponse = {
  content?: ImageResponse[];
  id?: string;
};
export type EntityMediaType = "image" | "video" | "audio";
export type VideoResponse = {
  cookies?: CookieResponse[];
  thumbnail?: ImageResponse[];
  url?: string;
};
export type VideoMediaResponse = {
  content?: VideoResponse;
  id?: string;
};
export type EntityMedia = {
  audio?: AudioMediaResponse;
  createdAt?: string;
  id?: string;
  image?: ImageMediaResponse;
  key?: string;
  type?: EntityMediaType;
  updatedAt?: string;
  video?: VideoMediaResponse;
};
export type EntityLanguage = "en" | "de" | "de";
export type EntityRole =
  | "rs-user"
  | "rs-admin"
  | "rs-system-admin"
  | "rs-tester";
export type EntityUserStatus =
  | "us-new"
  | "us-pending"
  | "us-active"
  | "us-deactivated"
  | "us-deleted";
export type EntityProductType = "pt-subscription" | "pt-credits";
export type EntityProduct = {
  createdAt?: string;
  description?: string;
  /** Product id of Google Play Store */
  googleVendorProductID?: string;
  id?: string;
  priceLevel?: number;
  /** The product can be a subscription or a one-time credit purchase. */
  type?: EntityProductType;
  updatedAt?: string;
  /** Product id of Apple App Store */
  vendorProductID?: string;
};
export type EntitySubscriptionPackage = {
  createdAt?: string;
  /** Credits included in the subscription package */
  credits?: number;
  description?: string;
  /** Duration in days/months, only informative, true duration is defined by the plan on Apple/Google */
  duration?: number;
  id?: string;
  name?: string;
  plan?: "sp-basic" | "sp-premium";
  product?: EntityProduct;
  status?: "sps-active" | "sps-inactive";
  updatedAt?: string;
};
export type EntitySubscription = {
  cancelledAt?: string;
  createdAt?: string;
  endsAt?: string;
  id?: string;
  startsAt?: string;
  status?: "ss-active" | "ss-canceled" | "ss-expired";
  subscriptionPackage?: EntitySubscriptionPackage;
  updatedAt?: string;
  vendor?: "sv-google" | "sv-apple";
};
export type EntityUserOrigin =
  | "uo-facebook"
  | "uo-google"
  | "uo-apple"
  | "uo-internal";
export type EntityUser = {
  /** BlockedFeatures lists feature keys that are disabled for this user (e.g. chat, payments). */
  blockedFeatures?: string[];
  createdAt?: string;
  credits?: number;
  email: string;
  id?: string;
  image?: EntityMedia;
  language?: EntityLanguage;
  name?: string;
  role?: EntityRole;
  sendNotifications?: boolean;
  status?: EntityUserStatus;
  subscription?: EntitySubscription;
  timezone?: string;
  updatedAt?: string;
  userOrigin?: EntityUserOrigin;
};
export type EntityPayment = {
  /** Used by Apple Billing Api */
  appleTransactionID?: string;
  createdAt?: string;
  /** Used by Google Billing Api */
  googleOrderID?: string;
  googlePurchaseToken?: string;
  id?: string;
  paymentVendor?: EntityPaymentVendor;
  priceCurrencyCode?: string;
  priceMicros?: number;
  status?: EntityPaymentStatus;
  updatedAt?: string;
  user?: EntityUser;
  vendorProductID?: string;
};
export type BackOfficePaymentPage = {
  count?: number;
  items?: EntityPayment[];
  last?: boolean;
  page?: number;
  size?: number;
};
export type ValidationError = {
  field?: string;
  message?: string;
};
export type ErrorResponse400 = {
  code?: number;
  data?: ValidationError[];
  message?: string;
};
export type ErrorResponse404 = {
  code?: number;
  data?: {
    [key: string]: string;
  }[];
  message?: string;
};
export const { useGetBackOfficeListPaymentsQuery } = injectedRtkApi;
